import {
  createFileRoute,
  Link,
  MatchRoute,
  notFound,
  Outlet,
} from "@tanstack/react-router";
import { SidebarRailWithLabels } from "@op/sf-editor";
import {
  FeatherBuilding,
  FeatherChevronLeft,
  FeatherFolder,
  FeatherUsers,
} from "@subframe/core";

export const Route = createFileRoute("/admin")({
  beforeLoad: ({ context: { sessionData } }) => {
    if (sessionData?.user.role !== "admin") {
      return notFound();
    }
  },
  component: AppAdminLayout,
});

function AppAdminLayout() {
  return (
    <div className={"flex h-screen w-full items-center"}>
      <SidebarRailWithLabels
        className="h-auto w-auto flex-none self-stretch"
        footer={
          <Link to="/app">
            <SidebarRailWithLabels.NavItem icon={<FeatherChevronLeft />}>
              Back
            </SidebarRailWithLabels.NavItem>
          </Link>
        }
      >
        <Link to="/admin/users">
          <MatchRoute to="/admin/users">
            {(match) => {
              return (
                <SidebarRailWithLabels.NavItem
                  icon={<FeatherUsers />}
                  selected={!!match}
                >
                  Users
                </SidebarRailWithLabels.NavItem>
              );
            }}
          </MatchRoute>
        </Link>
        <Link to="/admin/orgs">
          <MatchRoute to="/admin/orgs">
            {(match) => (
              <SidebarRailWithLabels.NavItem
                icon={<FeatherBuilding />}
                selected={!!match}
              >
                Orgs
              </SidebarRailWithLabels.NavItem>
            )}
          </MatchRoute>
        </Link>
        <Link to="/admin/projects">
          <MatchRoute to="/admin/projects">
            {(match) => (
              <SidebarRailWithLabels.NavItem
                icon={<FeatherFolder />}
                selected={!!match}
              >
                Projects
              </SidebarRailWithLabels.NavItem>
            )}
          </MatchRoute>
        </Link>
      </SidebarRailWithLabels>
      <div className="flex grow shrink-0 basis-0 flex-col items-start gap-4 self-stretch overflow-y-auto bg-default-background">
        <Outlet />
      </div>
    </div>
  );
}
